import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const Uti = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if (ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="UTI" />
                    <div style={{ textAlign: "left" }}>

                        <Input label="UTI" nome="nomedautia" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="60vw" widthMobile="80vw" marginR="3vw" />
                        <Select label="Tipo" nome="utiespecialista" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw"
                            array={["UTI ADULTO", "UTI NEONATAL", "UTI PEDIÁTRICA"]} />
                        <Select label="Tipo da Equipe" nome="utitipoequipe" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Equipe Própria", "Híbrida", "Terceirizada"]} />
                        <Input label="Nº de Leitos" nome="utialeitos" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Durante a Fiscalização" nome="utiapacientesfiscalizacao" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Assistidos pela Fisioterapia" nome="utiapacientesassistidos" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                    </div>

                    <HeaderVerde texto="FISIOTERAPEUTA NO SETOR DURANTE A INSPEÇÃO" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Quantos Fisioterapeutas no Setor" nome="utifisioescala" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        {RenderQtdFisio()}
                    </div>

                    <HeaderVerde texto="PROFISSIONAIS NA ESCALAS" />
                    <div style={{ textAlign: "left" }}>

                        <Input label="Total de Plantonistas/Diarista na Escala" nome="utiqtdescala" modulo={modulo} index={n}
                            widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Select label="Assistência Fisioterapêutica 7 dias/Semanas" nome="utiassistencia7" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["sim", "não"]} />
                        <Select label="Mínimo de 01 Fisioterapeuta para cada 10 leitos ou fração" nome="utifisioleitos" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["sim", "não"]} />
                        <Select label="Jornada de Assistência da Fisioterapia" nome="utiabls" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["< 18h/dia", "18h/dia", "24h/dia", "18h/dia"]} />
                        <Select label="Jornada de Assistência Exclusiva do Setor" nome="utibls" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["sim", "não"]} />
                        <Select label="Exclusividade do Fisioterapeuta para Asssistência no Setor" nome="utifisioExclusividade" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>

                    <HeaderVerde texto="FISIOTERAPEUTA COORDENADOR" />
                    <div style={{ textAlign: "left" }}>

                        <Input label="Nome" nome="utifisiocoordenador" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="31vw" widthMobile="80vw" marginR="3vw" />
                        <Select label="Título de Especialista (RDC07/2010 ANVISA)" nome="utitituloespecialista" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="21vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não", "Não há coordenador"]} />
                        <Select label="Coordenador Possui Jornada Horizontal de 6h" nome="uticoordenadorhorizontal" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="21vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não", "Não há coordenador"]} />

                    </div>
                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="CONFORMIDADE COM A RESOLUÇÃO COFFITO Nº  444/2014" nome="resolucao444" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="25vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                </Caixa >
            )

            function RenderQtdFisio() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["utifisioescala"]
                if (array[modulo][n]["utifisioescala"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>
                                <Input label="Profissional" nome="utinomedoprofissional"
                                    modulo={modulo} index={n} subModulo="utinomedoprofissional" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="30vw" widthMobile="80vw" marginR="3vw" />

                                <Select label="Jornada de Trabalho" nome="utijornada"
                                    modulo={modulo} index={n} subModulo="utijornada" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                                    array={["Diarista", "Plantonista", "Ambos"]} />

                                <Select label="Horário de Trabalho" nome="utihrtrabalho"
                                    modulo={modulo} index={n} subModulo="utihrtrabalho" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                                    array={["12h diurno", "12h noturno", "6h matutino", "6h vespertino", "6h noturno", "24 horas"]} />
                            </div>
                        )
                    }
                }
                return campos
            }
        }
        return partes
    }
}

export default Uti